import { store } from '@/store/index.js';

function getClubByParam (params = {}) {
	const { clubId, competitionId, membershipId } = params;

	if (clubId) return clubId;

	if (competitionId) {
		return store.getters[`competition/getById`](competitionId).clubId;
	} else if (membershipId) {
		return store.getters[`membership/getById`](membershipId).clubId;
	}
}

function showPermissionDeniedError() {
	store.commit(`vcl/notificationBar/show`, {
		text: `Permission denied.`,
		type: `error`
	});
}

function isAuthorized () {
	return (to, from) => {
		const { hasRole } = to.meta;

		// allow the user to proceed if hasRole param not set
		if (!hasRole || hasRole.length === 0) return;

		const clubId = getClubByParam(to.params);

		// no club was found send a permission denied error and prevent the user from proceeding
		if (!clubId) {
			showPermissionDeniedError();

			return from;
		}

		const passesAdminCheck = hasRole.includes(`club:admin`) ? store.getters[`club/hasAdminPrivileges`](clubId) : true;
		const passesOwnerCheck = hasRole.includes(`club:owner`) ? store.getters[`club/hasRole`](clubId, `club:owner`) : true;

		// user has the necessary permissions
		// allow them to proceed
		if (passesAdminCheck && passesOwnerCheck) return;

		// user doesn't have the necessary permissions
		// show a permission denied error and prevent the user from proceeding
		showPermissionDeniedError();

		return from;
	};
}

export { isAuthorized };
